import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static values = {
    refreshInterval: Number,
    complete: String,
    completeModal: String,
    verifyStatusUrl: String,
    limit: Boolean,
  };

  connect() {
    if (this.completeValue) {
      this.openModal();
    } else {
      if (this.hasRefreshIntervalValue) {
        this.limitValue = false;
        this.startRefreshing();
      }
    }
  }

  disconnect() {
    this.stopRefreshing();
  }

  openModal() {
    var targetModal = document.querySelector(this.completeModalValue);
    targetModal.showModal();
    targetModal.classList.add("is-open");
    this.htmlFix();
  }

  //スクロール禁止状態にする
  htmlFix() {
    var st = $(window).scrollTop() * -1;
    $("html").addClass("is-fixed");
    $("body").css("top", st);
  }

  startRefreshing() {
    this.refreshTimer = setInterval(() => {
      this.errorMessage();
      this.limitValue = true;
      this.stopRefreshing();
    }, this.refreshIntervalValue);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  errorMessage(message) {
    if (message) {
      $("#error-message-text").html('<span class="icon-alert">注意</span>' + message);
    } else {
      $("#error-message-text").html(
        '<span class="icon-alert">注意</span>認証コードが無効となりました。再度認証方法を選択して操作を行ってください。',
      );
    }
    $("#error-message").fadeIn();
    $("#account-code-button").css("pointer-events", "none");
  }

  toastClose(e) {
    const toast = $(e.currentTarget).closest(".js-toast");

    toast.fadeOut();
  }

  verifyStatusCheck() {
    this.fetchDataInInterval();
  }

  fetchDataInInterval() {
    return new Promise(() => {
      const url = this.verifyStatusUrlValue;
      const token = document.getElementsByName("csrf-token")[0].content;
      const headers = {
        "X-CSRF-Token": token,
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      fetch(url, {
        method: "GET",
        headers: headers,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }
          return response.json();
        })
        .then((data) => {
          if (data.result) {
            this.openModal();
            this.stopRefreshing();
          } else {
            if (data.error_message) {
              this.errorMessage(data.error_message);
              this.stopRefreshing();
            } else {
              throw new Error();
            }
          }
        })
        .catch(() => {
          if (!this.limitValue) {
            setTimeout(() => {
              this.fetchDataInInterval();
            }, 5000);
          }
        });
    });
  }
}
